import httpInstance from '../httpInstance';

const deleteBannerService = async (promoId) => {
  let res;
  const endpoint = `/frontlabels/v1/promos/${promoId}`;

  await httpInstance.delete(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default deleteBannerService;
